import React from 'react';
import PropTypes from 'prop-types';

const OKModal = require('components/commons/OKModal/OKModal');

class ConfirmModal extends React.PureComponent {
    constructor(props){
        super(props)

        this.state = {
            open: props.open
        }
    }

    componentWillReceiveProps(props, state){
        if (state.open != props.open) {
            this.setState({
                open: props.open
            })
        }

        return null
    }

    handleCancel = () => {
        const { onCancel } = this.props

        onCancel && onCancel()
        this.setState({open: false})
    }

    handleAccept = () => {
        const { onAccept } = this.props

        onAccept && onAccept()
        this.setState({open: false})
    }

    render() {
        const { open } = this.state
        const {
            title,
            text,
            acceptButtonText,
            cancelButtonText,
            isLoadingAccept
        } = this.props;

        return (
            <OKModal
                description={text}
                footerType="navigation"
                isOpen={open}
                onCloseCallback={this.handleCancel}
                onPrimaryButtonClick={this.handleAccept}
                onSecondaryButtonClick={this.handleCancel}
                primaryButtonLoading={isLoadingAccept}
                primaryButtonText={acceptButtonText}
                secondaryButtonText={cancelButtonText}
                title={title}
            />
        );
    }
}

ConfirmModal.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    text: PropTypes.string,
    acceptButtonText: PropTypes.string,
    onAccept: PropTypes.func,
    cancelButtonText: PropTypes.string,
    onCancel: PropTypes.func,
    isLoadingAccept: PropTypes.bool
}

ConfirmModal.defaultProps = {
    title: '',
    text: '',
    acceptButtonText: 'confirmModal-acceptButton',
    cancelButtonText: 'confirmModal-cancelButton',
    isLoadingAccept: false
}

export { ConfirmModal };
